import { Suspense } from 'react';
import Loading from 'components/Loading';

export const suspense = Component => (
  <Suspense fallback={<Loading />}>
    <Component />
  </Suspense>
);
